import { type RouteConfig } from 'vue-router'

import { dispatchNewsArticles } from './newsArticle.store'

export const NewsArticleRouter: RouteConfig[] = [
  {
    path: '/newsArticles',
    component: async () => import('./NewsArticles.vue'),
    async beforeEnter(to, from, next): Promise<void> {
      await dispatchNewsArticles('list')
      next()
    },
  },
]
